// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgExternalIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M19 14v6c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1H5v12h12v-5c0-.55.45-1 1-1s1 .45 1 1m1.92-10.38A1.02 1.02 0 0 0 20 3h-6c-.55 0-1 .45-1 1s.45 1 1 1h3.59l-8.3 8.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L19 6.41V10c0 .55.45 1 1 1s1-.45 1-1V4c0-.13-.03-.26-.08-.38" />
  </g>
);
export default SvgExternalIcon;
SvgExternalIcon.displayName = 'SvgExternalIcon';
